import { render, staticRenderFns } from "./ModuleBalanceCard.vue?vue&type=template&id=74ec6674&scoped=true&"
import script from "./ModuleBalanceCard.vue?vue&type=script&lang=js&"
export * from "./ModuleBalanceCard.vue?vue&type=script&lang=js&"
import style0 from "./ModuleBalanceCard.vue?vue&type=style&index=0&id=74ec6674&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74ec6674",
  null
  
)

export default component.exports